/**
 * @desc 新增NFT作品
 */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/item/addItem', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/item/addItem', params);
}
